import React, { useState, useEffect } from 'react';
import { DEFAULT_SYSTEM_PROMPT } from "../constants/system_prompt_constant"

const Settings = ({ isOpen, onClose, defaultApiUrl, onApiUrlChange, defaultSystemPrompt, onSystemPromptChange }) => {
  const [apiUrl, setApiUrl] = useState(defaultApiUrl);
  const [systemPrompt, setSystemPrompt] = useState(defaultSystemPrompt || DEFAULT_SYSTEM_PROMPT);

  // Update state when props change
  useEffect(() => {
    setApiUrl(defaultApiUrl);
    setSystemPrompt(defaultSystemPrompt || DEFAULT_SYSTEM_PROMPT);
  }, [defaultApiUrl, defaultSystemPrompt]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onApiUrlChange(apiUrl);
    onSystemPromptChange(systemPrompt);
    onClose();
  };

  const handleResetSystemPrompt = () => {
    setSystemPrompt(DEFAULT_SYSTEM_PROMPT);
  };

  if (!isOpen) return null;

  return (
    <div className="settings-modal-overlay">
      <div className="settings-modal">
        <div className="settings-header">
          <h2>Settings</h2>
          <button onClick={onClose} className="close-button">×</button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="apiUrl">API URL:</label>
            <textarea
              id="apiUrl"
              value={apiUrl}
              onChange={(e) => setApiUrl(e.target.value)}
              placeholder="Enter API URL"
              rows="3"
              required
            />
          </div>
          <div className="form-group">
            <div className="system-prompt-header">
              <label htmlFor="systemPrompt">System Prompt:</label>
              <button 
                type="button" 
                onClick={handleResetSystemPrompt} 
                className="reset-prompt-button"
              >
                Reset to Default
              </button>
            </div>
            <textarea
              id="systemPrompt"
              value={systemPrompt}
              onChange={(e) => setSystemPrompt(e.target.value)}
              placeholder="Enter system prompt"
              rows="5"
            />
            <p className="prompt-help-text">The system prompt sets the behavior and context for the AI assistant.</p>
          </div>
          <div className="settings-footer">
            <button type="button" onClick={onClose} className="cancel-button">
              Cancel
            </button>
            <button type="submit" className="save-button">
              Save Changes
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Settings;